import { Platform, StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    container: {
        height: 56,
        marginBottom: 8,
        alignItems: 'center',
        borderRadius: 6,
        backgroundColor: COLOR.DARK_GREY,
        flexDirection: 'row',
        justifyContent: 'flex-start',
        paddingHorizontal: 16,
    },
    icon: {
        width: 32,
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 16,
    },
    arrow: {
        position: 'absolute',
        right: 23,
    },
    titleContainer: {
        flex: 1,
    },
    title: {
        lineHeight: 24,
    },
    subtitle: {
        lineHeight: 19,
        marginTop: Platform.select({ web: 0, default: 3 }),
    },
    rightSubtitle: { flex: 1, marginLeft: 5, textAlign: 'right' },
});

export default styles;
